export default "__VITE_ASSET__b94c565d__"